import { render, staticRenderFns } from "./GridProducts.vue?vue&type=template&id=6a1a8a17&scoped=true&"
import script from "./GridProducts.vue?vue&type=script&lang=js&"
export * from "./GridProducts.vue?vue&type=script&lang=js&"
import style0 from "./GridProducts.vue?vue&type=style&index=0&id=6a1a8a17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a8a17",
  null
  
)

export default component.exports